import { Component } from 'react'

import { NetworkAutocomplete } from '../NetworkAutocomplete/NetworkAutocomplete'
import { AutocompleteResult } from '../NetworkAutocomplete/NetworkAutocompleteOption'
import { IOrganizationJSON, IOrganizationResJSON } from './OrganizationsModel'

export interface IOrganizationAutocompleteProps {
  searchOrganizations: (searchText: string) => Promise<IOrganizationResJSON>
  handleOrganizationSelection: (selection: AutocompleteResult) => void
}

export class OrganizationAutocomplete extends Component<IOrganizationAutocompleteProps> {
  constructor(props) {
    super(props)
    this.getCompletions = this.getCompletions.bind(this)
    this.formatOrganizationToCompletion = this.formatOrganizationToCompletion.bind(this)
  }

  getCompletions(searchText: string): Promise<AutocompleteResult[]> {
    return this.props
      .searchOrganizations(searchText)
      .then((results) => results.data.map(this.formatOrganizationToCompletion))
  }

  formatOrganizationToCompletion(organization: IOrganizationJSON): AutocompleteResult {
    return { label: organization.name, value: organization._id, data: { entity: organization } }
  }

  render() {
    return (
      <NetworkAutocomplete
        getCompletions={this.getCompletions}
        handleSelection={this.props.handleOrganizationSelection}
      />
    )
  }
}
